import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=365d1347&scoped=true"
import script from "./Accordion.vue?vue&type=script&lang=ts&setup=true"
export * from "./Accordion.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "365d1347",
  null
  
)

export default component.exports